import React, { useEffect, useState } from 'react';
import { api } from '../../api';
import { Card } from '../../components/ui/card';
import { Button } from '../../components/ui/button';
import { Badge } from '../../components/ui/badge';
import { Input } from '../../components/ui/input';
import { toast } from 'sonner';

const STATUS_OPTS = ['PENDING_PAYMENT','PAID','CHECKED_IN','CHECKED_OUT','CANCELLED','HOLD'];

export default function AdminBookings() {
  const [rows, setRows] = useState([]);
  const [q, setQ] = useState('');
  const load = () => api.get('/bookings').then(r => setRows(r.data));
  useEffect(() => { load(); }, []);
  const setStatus = async (id, status) => { await api.patch(`/bookings/${id}/status`, { status }); toast.success('Updated'); load(); };
  const filtered = rows.filter(r => !q || [r.dog_name, r.client_name, r.run_name, r.client_email].some(x => (x||'').toLowerCase().includes(q.toLowerCase())));
  return (
    <div className='p-6 lg:p-8'>
      <div className='flex items-center justify-between mb-4'>
        <div>
          <div className='text-[10px] uppercase tracking-[0.16em] font-bold text-[#C8102E]'>All</div>
          <h1 className='font-display text-3xl font-bold text-slate-900 mt-1'>Bookings</h1>
        </div>
        <Input placeholder='Search dog, client, run…' value={q} onChange={(e)=>setQ(e.target.value)} className='w-80 bg-white border-slate-200 text-slate-900' data-testid='bookings-search-input' />
      </div>
      <Card className='bg-white border-slate-200 overflow-x-auto'>
        <table className='w-full text-sm' data-testid='admin-bookings-table'>
          <thead>
            <tr className='border-b border-slate-200 text-left'>
              {['Dog','Client','Run','Dates','Nights','Amount','Status','Actions'].map(h => <th key={h} className='p-3 text-[10px] uppercase tracking-wider font-bold text-slate-500'>{h}</th>)}
            </tr>
          </thead>
          <tbody>
            {filtered.map(b => (
              <tr key={b.id} className='border-b border-slate-200 hover:bg-slate-50' data-testid={`bk-row-${b.id}`}>
                <td className='p-3 font-semibold'>{b.dog_name}</td>
                <td className='p-3'><div>{b.client_name}</div><div className='text-xs text-slate-500 font-mono'>{b.client_email}</div></td>
                <td className='p-3 font-mono'>{b.run_name}<div className='text-[10px] text-slate-500'>{b.run_type}</div></td>
                <td className='p-3 text-xs'>{new Date(b.start).toLocaleDateString()} → {new Date(b.end).toLocaleDateString()}</td>
                <td className='p-3 tabular-nums'>{b.nights}</td>
                <td className='p-3 font-display font-bold tabular-nums'>${b.amount.toFixed(2)}</td>
                <td className='p-3'><Badge>{b.status.replace('_',' ')}</Badge></td>
                <td className='p-3'>
                  <select className='h-9 rounded-md border border-slate-200 bg-slate-50 px-2 text-xs text-slate-900' value={b.status} onChange={(e)=>setStatus(b.id, e.target.value)} data-testid={`status-select-${b.id}`}>
                    {STATUS_OPTS.map(s => <option key={s} value={s}>{s.replace('_',' ')}</option>)}
                  </select>
                </td>
              </tr>
            ))}
            {filtered.length === 0 && <tr><td colSpan={8} className='p-6 text-center text-slate-500'>No bookings found.</td></tr>}
          </tbody>
        </table>
      </Card>
    </div>
  );
}
